import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  congViecPaging: {},
  danhSachCongViec: [],
  danhSachTrangThaiCv: [],
  danhSachDonViTaoCongViec: [],
  danhSachDonViGanCongViec: [],
  chiTietCongViec: [],
  danhSachCongViecLQ: [],
  danhSachLichSuGiaoViec: [],
  danhSachMucDoCongViec: [],
  danhSachLichSuThayDoiTrangThaiCongViec: [],
  danhSachHienThiCotCongViec: [],
  danhSachHienThiCotCongViecCapNhat: [],
  danhSachLichSuDonDocCongViec: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
